import { createContext, RefObject, useContext } from "react";
import { SheetModalProps } from ".";

export type UseSheetModalType = SheetModalProps & {
    open?: boolean;
    onClickClose?: (e: any) => void;
    closeModal?: (e: any) => void;
    nextLevel?: (level: number) => void;
    previousLevel?: (level: number) => void;
    onApplySheet?: (e?: any) => void;
    sheetFooter?: boolean;
    sheetId?: string;
    headingId?: string;
    headingRef?: RefObject<HTMLElement>;
    currentLevel?: number;
    maxLevel?: number;
};

const initialValue: UseSheetModalType = {
    title: "Modal"
};

const SheetModalContext = createContext(initialValue);

export const useSheetModalContext = () => {
    const context = useContext(SheetModalContext);
    return context;
}

export const SheetModalWrapper = ({ children, ...rest }: any) => {
    return <SheetModalContext.Provider value={rest}>
        <SheetModalContext.Consumer>
            {() => children}
        </SheetModalContext.Consumer>
    </SheetModalContext.Provider>
}